import * as React from 'react';
import { Box } from '@leagueplatform/genesis-core';
import { useStaticAsset } from '@leagueplatform/asset-config';
import { CHAT_HISTORY_MODULE_ASSET_KEYS } from '../../asset-map';

const AVATAR_SIZE = 32;

export const SenderAvatar = (props: {
  senderAvatar?: string;
  // eslint-disable-next-line react/no-unused-prop-types
  senderName?: string;
}): React.ReactElement => {
  const { senderAvatar } = props;
  const fallbackAvatar = useStaticAsset(
    CHAT_HISTORY_MODULE_ASSET_KEYS.FALLBACK_AVATAR,
  ) as string;

  return (
    <Box
      as="figure"
      aria-hidden="true"
      css={{
        margin: 0,
        flexShrink: 0,
        width: AVATAR_SIZE,
        height: AVATAR_SIZE,
      }}
    >
      <Box
        as="img"
        src={senderAvatar || fallbackAvatar}
        alt=""
        css={{
          width: AVATAR_SIZE,
          height: AVATAR_SIZE,
          borderRadius: '50%',
          objectFit: 'cover',
        }}
      />
    </Box>
  );
};
